<template>
	<div class="error-page">
		<nut-icon
			name="warning-circle-fill"
			class-prefix="icon"
			font-class-name="iconfont"
			class="icon"
			size="100"
		>
		</nut-icon>
		<div class="msg">
			<div class="title">
				{{
					$route.query.title
						? decodeURIComponent($route.query.title)
						: '错误'
				}}
			</div>
			{{
				$route.query.msg
					? decodeURIComponent($route.query.msg)
					: '出错了，请关闭重新尝试'
			}}
		</div>
	</div>
</template>

<script>
export default {
	name: 'Error',
	setup() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.error-page {
	height: 40vh;
	@include flex-center;
	flex-direction: column;
	justify-content: center;

	.icon {
		color: #f76260;
	}

	.msg {
		margin-top: 20px;
		padding: 0 15px;
		text-align: center;
		line-height: 24px;
		font-size: $normal-font-size;
		color: $grey-font-color;

		.title {
			margin-bottom: 10px;
			font-size: $large-font-size;
			color: $base-font-color;
		}
	}
}
</style>
